// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1Iqgo","log":"ModalInventoryLogs_log__2M3X9","date":"ModalInventoryLogs_date__1UXds","userName":"ModalInventoryLogs_userName__3dubD"};